var lib_core      = require("lib-core");
var ui_extensions = require("ui-extensions");
var cio_datamodel = require("cio-datamodel");
var editor_3d = require("editor-3d-light");
var lib_geometry = require("lib-geometry");

var IpcNameHelper = cio_datamodel.IpcNameHelper;
var IpcDescriptionHelper = cio_datamodel.IpcDescriptionHelper;
var IpcPackageParamHelper = cio_datamodel.IpcPackageParamHelper;

var PackageGeneratorInteractionModel = require("./packageGeneratorInteractionModel.js");

 var PackageGeneratorModel = function(data, dataLoader, switcherModel, packageViewerModel, processMessageModel, masterModel, userSettingsModel, versionModel, editorView, configuration) {
    var self = this;

    lib_core.Model.call(this);

    //persistent data
    this.data = data;

    //non-persistent data
    this.dummyPackageData = new cio_datamodel.PackageData(true);

    //attach to dummy root
    var dummyRoot = new lib_core.Root();
    dummyRoot.attachData(this.dummyPackageData);

    this.switcherModel = switcherModel;

    this.packageViewerModel = packageViewerModel;
    this.processMessageModel = processMessageModel;
    this.masterModel = masterModel;
    this.configuration = configuration;
    this.dataLoader = dataLoader;

    // fusion stuff
    this.useEditor = this.configuration.useEditor || this.configuration.useEditor === undefined;
    // this.customDownloadFootprint = this.configuration.customDownloadFootprint;
    // this.customDownloadModelParameters = this.configuration.customDownloadModelParameters;
    // this.customDownloadIPCData = this.configuration.customDownloadIPCData;
    this.customDownloadPackageData = this.configuration.customDownloadPackageData;
    this.selectedPackage = this.configuration.selectedPackage;
    this.useLoadingScreen = this.configuration.useLoadingScreen || this.configuration.useLoadingScreen === undefined;
    this.dataUnit = this.configuration.dataUnit;
    this.editorUnit = this.configuration.editorUnit;
    this.editorLocale = this.configuration.editorLocale;
    this.withCustomFootprintParams = this.configuration.customFootprintSettings;

    this.userSettingsModel = userSettingsModel;
    this.userSettingsModel.distanceUnit(this.editorUnit);
    this.userSettingsModel.locale(this.editorLocale);
    
    this.versionModel = versionModel;

    this.editorView = editorView;

    //toggle button name
    this.toggleButtonName = this.value("toggleButtonName", true);

    //show toggle button
    this.showToggleButton = this.value("showToggleButton", true);

    //generator title
    this.generatorSidebarTitle = this.value("generatorSidebarTitle", true);

    //generator search box
    this.showPackageSearchBox = this.value("showPackageSearchBox", true);
    this.packageGeneratorSearchName = this.value("packageGeneratorSearchName", true);

    //boolean to check whether 3d model specific parametrs updated or not
    this.is3dModelParameterUpdated = true;

    //for showing sidebar containing package generators
    this.showGenerator = this.value('showGenerator', true);
    this.showGenerator(false);

    //warning popup for saved package overwriting
    this.showPackageOverwritingWarningPopup = this.value('showPackageOverwritingWarningPopup', true);

    //warning popup for finishing generation when user clicks finish button
    this.showWarningPopupForFinishingGeneration = this.value('showWarningPopupForFinishingGeneration', true);

    //warning popup for unfinished update preview when IPC data is updated recently and user clicks on finish button
    this.showWarningPopupForUnfinishedPackageUpdatePreview = this.value('showWarningPopupForUnfinishedPackageUpdatePreview', true);

    //warning popup for forking current package
    this.showWarningPopupForOpeningForkedPackage = this.value("showWarningPopupForOpeningForkedPackage", true);

    //show finish button
    this.showFinishButton = this.value("showFinishButton", true);

    //show IPC params in read only mode
    this.showIPCParametersInReadOnlyMode = this.value("showIPCParametersInReadOnlyMode", true);
    this.showIPCParametersInReadOnlyMode(false);

    //set this flag to true while IPC params are updated in generator
    //if this flag is set to true show update preview button else disable it
    //note: this flag has different purpose than isIPCDataAnd3DModelOutOfSync which is related to saved IPC data and saved 3d model but this flag is related to saved IPC data and dummy assets
    this.isParametricDataDirty = this.value("isParametricDataDirty", true);

    this.isFusionPackagePresent = false;

    //interaction model for package parametric data
    this.selectedIM = this.value("selectedIM", true);

    //for inspector
    this.readOnly = this.value('readOnly', true);
    if(this.configuration && this.configuration.read_only) {
        this.readOnly(this.configuration.read_only);
    }

    //need to add here to work with inspector SM
    this.focus = this.value("focus", true); //TODO: can be removed?

    this.processMessageKey = "Dummy Package";

    this.versionDescription = {
        saveGenerated3dModel: '3D model created using Model Generator',
        saveGeneratedFootprint: 'Created by IPC generator',
        saveGeneratedPackage: 'Auto Generated Package'
    };

    //flag for overriding settings during saving generated 3d model
    this.overridePackageSettings = this.value("overridePackageSettings", true);
    this.overridePackageSettings(false);

    //store transformations done on dummy 3d model in nonwizard mode
    //transformation done on dummy 3d model must be preserved after saving generated 3d model
    //note: transformation vectors get reset when 3d model is saved
    this.dummyModel3dPosition = this.value("dummyModel3dPosition", true);
    this.dummyModel3dRotation = this.value("dummyModel3dRotation", true);

    //forked package url
    this.forkedPackageURL = "";

    //preview package title
    this.previewPackageName = this.value("previewPackageName", true);

    //list of hubs
    this.hubsList = this.value("hubsList", true);

    //fork mode
    //Mode 1 - Start from IPC params
    //Mode 2 - Fork full public package
    this.forkMode = "";

    this.FORK_MODE_CONSTANT = {
        MODE_1: "IPC",
        MODE_2: "PUBLIC"
    }

    this.only3dModelGenerator = this.configuration.only3dModelGenerator === "true" || this.configuration.only3dModelGenerator === "1";

    // I don't think we care about this logic in fusion.  some parameters will be generating a footprint
    // and a model, we can configure the editor to only save one or the other, we don't need
    // the logic to decide whether or not to generate one or both.
    if(this.useEditor){
        this.only3dModelGeneratedFromIPCParam = this.cachedFunction("only3dModelGeneratedFromIPCParam",
            function(){
                var currentFootprintInstanceIM = this.packageViewerModel.currentFootprintModel();

                //for old assets do check on save points since isOnly3dModelGeneratedFromIPCParam is null
                //if footprint instance has initial import save point it is not generated from IPC data
                return (this.data.isOnly3dModelGeneratedFromIPCParam() == null)
                    ? currentFootprintInstanceIM.hasInitialImportSavePoint()
                    : this.data.isOnly3dModelGeneratedFromIPCParam();
            },

            [this.data.isOnly3dModelGeneratedFromIPCParam, this.packageViewerModel.currentFootprintModel]
        );
    } else {
        this.only3dModelGeneratedFromIPCParam = function(){ return false; }
    }

    this.initListeners();

    if(this.masterModel && this.masterModel.wizardMode()) {
        this.showGenerator(true);
        this.toggleButtonName(this.configuration.button.wizardMode.name);
        this.generatorSidebarTitle(this.configuration.sidebar.wizardMode.title);
    } else if(this.masterModel && !this.masterModel.wizardMode()) {
        this.toggleButtonName(this.configuration.button.nonWizardMode.name);
        this.generatorSidebarTitle(this.configuration.sidebar.nonWizardMode.title);
        this.checkAndShowModelGenerateButton();
    }

    if(this.data.ipcParametricData()) {
        //if wizard mode is enabled create IM for 3D package generator and generate 3D package on initial loading
        //else create IM containing only 3D model related fields
        if(this.masterModel && this.masterModel.wizardMode()) {
            this.createInteractionForParametricData(this.data.ipcParametricData(), !self.only3dModelGenerator);
            this.isParametricDataDirty(true);
            if(this.useEditor) this.generatePackage();
        } else if(this.masterModel && !this.masterModel.wizardMode()) {
            this.createInteractionForParametricData(this.data.ipcParametricData(), false);

            //if the IPC data is out of sync with 3d model set IPC parameter dirty flag to true
            if(this.data.isIPCDataAnd3DModelOutOfSync()) {
                this.isParametricDataDirty(true);

                //generate 3d model if saved 3d model is not from manual upload
                if(!this.data.is3dModelUploadedManually()) {
                    this.generate3dModel();
                    this.showGenerator(true);
                }
            }
        }

        //attach listeners on parametric data on page reload
        this.data.ipcParametricData().onBubble(self, function(event) {
            self.onIpcParametricDataUpdatedEvent(event);
        });
    }
};

lib_core.inherit(PackageGeneratorModel, lib_core.Model);
PackageGeneratorModel.$class = "PackageGeneratorModel";
module.exports = PackageGeneratorModel;

PackageGeneratorModel.prototype.initIpcParametricDataOnChangeListener = function(newData, oldData) {
    var self = this;

    //attach listeners on parametric data to listen for change in ipc parametric data
    newData.onBubble(self, function(event) {
        self.onIpcParametricDataUpdatedEvent(event);
    });

    //remove old handlers if exists
    if(oldData) oldData.removeHandlers(self);

    //set paramteric data dirty
    if(!self.isFusionPackagePresent) {
        self.isParametricDataDirty(true);
    }

    //required for first selection of IPC data for generating package
    self.is3dModelParameterUpdated = true;
};

PackageGeneratorModel.prototype.initListeners = function() {
    var self = this;

    //create package generator interaction when parametric data is changed
    this.data.ipcParametricData.onChange(this, function(newData, oldData) {
        if(newData) {
            if(self.masterModel && self.masterModel.wizardMode()) {
                self.createInteractionForParametricData(newData, !self.only3dModelGenerator);
            } else if(self.masterModel && !self.masterModel.wizardMode()) {
                self.createInteractionForParametricData(newData, false);
            }

            self.initIpcParametricDataOnChangeListener(newData, oldData);
        } else {
            //this block is executed when ipc parametric data is cleared
            //hide IPC form
            self.selectedIM(null);

            //hide finish button
            self.showFinishButton(false);

            self.isParametricDataDirty(false);

            self.showIPCParametersInReadOnlyMode(false);

            self.showPackageSearchBox(false);
            
            //set default new package name
            if(self.masterModel && self.masterModel.wizardMode()) {
                self.previewPackageName(self.data.metaData().name());
            }

            //TODO: what to do with preview on undo?
        }
    });

    //when new dummy footprint instance is added add it to switcher
    if(self.useEditor){
        this.dummyPackageData.footprintInstances.onAdd(this, function(idx, instance) {
           var switcherItemModel = new ui_extensions.SwitcherItemModel(instance, 0);
           self.switcherModel.items.push(switcherItemModel);
        });


        //when a footprint instace is removed clear the scene and remove it from switcher
        this.dummyPackageData.footprintInstances.onRemove(this, function(idx, instance) {
          //checks to see if data is selected (TODO make it a function of switcher)
          //this is needed to manually clear the scene
          if(self.switcherModel.selectedItem() && self.switcherModel.selectedItem().searchData(instance)){
              self.switcherModel.selectedItem().remove();
          }

          //switcher may contain saved footprint instances as well as dummy instances
          //get the start indices of dummy footprint instance and remove it
          var idxOffset = self.data.footprintInstances.size();

          //just remove the dummy item from switcher
          self.switcherModel.items.remove(idxOffset);
        });

        this.dummyPackageData.model3d.onChange(this, function(val) {
            if(val){
                self.updatePackageViewerModel();
            } else {
                //3d model is saved
                //hide finish button
                self.showFinishButton(false);

                //hide generator
                self.showGenerator(false);
            }
        });
    }

    this.data.model3d.onChange(this, function(val) {
        if(val){
            //close generator sidebar and clear model3d in dummy package data if the 3d model is uploaded manually
            if(self.data.is3dModelUploadedManually()) {
                self.closeGeneratorOnManual3dModelUpload();

                //if 3d model is only generated from IPC data set IPC data to null
                if(self.only3dModelGeneratedFromIPCParam()) {
                    self.data.ipcParametricData(null);
                }
            }
        }
    });

    this.isParametricDataDirty.onChange(this, function(val) {
        if(val) {
            self.data.isIPCDataAnd3DModelOutOfSync(true);
        } else {
            //update preview package title with IPC name in wizard mode
            if(self.masterModel && self.masterModel.wizardMode()) {
                if(self.data.ipcParametricData()) {
                    self.previewPackageName(IpcNameHelper.getIpcName(self.data.ipcParametricData()));
                }
            }
        }
    });

    this.data.is3dModelUploadedManually.onChange(this, function(val) {
        if(val) {
            self.isParametricDataDirty(true);
        } else {
            self.isParametricDataDirty(false);
        }
    });

    if(this.masterModel) {
        this.masterModel.wizardMode.onChange(this, function(mode) {
            //mode is switched from wizard mode to non-wizard mode
            if(!mode) {
                //hide finish button
                self.showFinishButton(false);

                //hide generator
                self.showGenerator(false);

                //update generator toggle button title
                self.toggleButtonName(self.configuration.button.nonWizardMode.name);

                //update generator title
                self.generatorSidebarTitle(self.configuration.sidebar.nonWizardMode.title);

                //hide generator button
                self.showToggleButton(false);

                //create IM only with 3D model related fields
                self.createInteractionForParametricData(self.data.ipcParametricData(), false);
            }
        });
    }

    if(self.useEditor){
      this.showFinishButton.onChange(this, function(show) {
          var currentFootprintInstanceIM = self.packageViewerModel.currentFootprintModel();

          if(show) {
              //clear model for showing warning popup again
              //this field is set when a version is created by clicking finish button
              self.showWarningPopupForFinishingGeneration(false);
          }
      });
    }

    //when IPC params in read only mode is about to be shown hide model generator, create IM with readonly IPC params persisted in the data and set the 'view IPC param' button active
    //and when it is closed set the 'view IPC param' button inactive again
    //note: higher value (2) is used as priority for this listener than the listener in view class.
    //listener with higher value has less priority. This is required to call resize editor after sidebar is shown from view class.
    this.showIPCParametersInReadOnlyMode.onChange(this, function(show) {
        var currentFootprintInstanceIM = self.packageViewerModel.currentFootprintModel();

        if(show) {
            self.showGenerator(false);
            self.createInteractionForParametricData(self.data.ipcParametricData(), !self.only3dModelGeneratedFromIPCParam());

            if(currentFootprintInstanceIM) currentFootprintInstanceIM.readOnlyIPCParamsVisible(true);
        } else {
            if(currentFootprintInstanceIM) currentFootprintInstanceIM.readOnlyIPCParamsVisible(false);
        }

        self.resizeEditor();
    }, 2);

    //when model generator is opened hide IPC params in read only mode, create IM with write only IPC params for updating 3d model, disable the 'view IPC param' button
    //when it is closed if finish button is not visible (package is finished) enable the 'view IPC param' button again
    //note: this listener is observed after the listener in view class for resize to work properly
    if(self.useEditor){
      this.showGenerator.onChange(this, function(show) {
          var currentFootprintInstanceIM = self.packageViewerModel.currentFootprintModel();

          if(show) {
              self.showIPCParametersInReadOnlyMode(false);
              if(self.data.ipcParametricData()) self.createInteractionForParametricData(self.data.ipcParametricData(), false);
              if(currentFootprintInstanceIM) currentFootprintInstanceIM.disableViewIPCParamButton(true);
          } else {
              if(!self.showFinishButton()) {
                  if(currentFootprintInstanceIM) currentFootprintInstanceIM.disableViewIPCParamButton(false);
              }
          }

          self.resizeEditor();
      }, 2);
    }

    //clear search box when its not visible
    this.showPackageSearchBox.onChange(this, function(val) {
        if(!val) {
            self.packageGeneratorSearchName("");
        }
    });

    if(self.configuration.respondToExternalEvent) {
        self.configuration.respondToExternalEvent(self.respondToExternalEventCallback.bind(self));
    }
};

PackageGeneratorModel.prototype.respondToExternalEventCallback = function(data) {
    var jsonData = JSON.parse(data);

    if (jsonData["model3dGeneration"]) {
        this.showFinishButton(jsonData["model3dGeneration"]["success"]);
    }
    // "jsonData" is package data from Fusion document 
    if (jsonData["packageType"]) {
        for(var member in this.selectedIM().parametricData) {
            if (typeof this.selectedIM().parametricData[member] === "function") {
                // get data member function name to check it in jsonData.
                var dataMember = this.selectedIM().parametricData[member]._name
                if (jsonData[dataMember]){
                    //set data member value from jsonData.
                    this.selectedIM().parametricData[member](jsonData[dataMember])
                }
            }   
        } 
        this.isFusionPackagePresent = true;
        this.isParametricDataDirty(false);
    }
};

//hide model generator button if the whole package is generated from IPC data
PackageGeneratorModel.prototype.checkAndShowModelGenerateButton = function() {
    //show model generator button if it is not hidden
    if(!this.configuration.button.hidden) {
        //show if there is no IPC data
        if(!this.data.ipcParametricData()) {
            this.showToggleButton(true);
        } else {
            //show if 3d model is only generated from IPC data
            if(this.only3dModelGeneratedFromIPCParam()) {
                this.showToggleButton(true);
            }
        }
    }
};

PackageGeneratorModel.prototype.closeGeneratorOnManual3dModelUpload = function() {
    this.showFinishButton(false);
    this.showGenerator(false);
    this.dummyPackageData.model3d(null);
    this.dummyPackageData.isIPCDataAnd3DModelOutOfSync(true);
};

//TODO: can we get rid of this?
PackageGeneratorModel.prototype.resizeEditor = function() {
    this.editorView.editorModel.canvasRect(this.editorView.getEditorSize());
};

PackageGeneratorModel.prototype.createInteractionForParametricData = function(parametricData, showFootprintParams) {
    //create IM with footprint parameters iff the package is generated from IPC data
    var im = new PackageGeneratorInteractionModel(parametricData, this.userSettingsModel, showFootprintParams, this.withCustomFootprintParams);
    this.selectedIM(im);
    this.isFusionPackagePresent = false;
    if(this.selectedPackage){
        this.selectedPackage(this.selectedIM().parametricData.constructor.$class);
    }    
};

PackageGeneratorModel.prototype.generateFootprintInstance = function() {
    var padGeneratorData = lib_core.clone(this.data.ipcParametricData());
    padGeneratorData.initialize();

    var footprintData = new cio_datamodel.FootprintData(true);
    footprintData.replicators.add(padGeneratorData);

    //update metadata for footprint
    //these are used for package too
    footprintData.metaData().name(IpcNameHelper.getIpcName(this.data.ipcParametricData()));
    footprintData.metaData().description('<p>' + IpcDescriptionHelper.getReadableDescriptionFromIPCData(this.data.ipcParametricData()) + '</p>');
    footprintData.metaData().summary(IpcDescriptionHelper.getShortDescriptionFromIPCData(this.data.ipcParametricData()));

    //jsonify footprint data
    var nonShareableDataRoot = new lib_core.NonShareableDataRoot();
    nonShareableDataRoot.attachData(footprintData);

    var jsonData = nonShareableDataRoot.jsonify(footprintData);

    var constructedJsonObjectForDescriptionRoot = {};
    constructedJsonObjectForDescriptionRoot["header"] = {};
    constructedJsonObjectForDescriptionRoot["body"] = jsonData;


    //create description root
    var footprintDescriptionRoot = new lib_core.DescriptionRoot(null, constructedJsonObjectForDescriptionRoot);

    //create footprint instance from footprint description and replace old in dummy non-persistant package data
    var footprintInstance = new cio_datamodel.FootprintInstanceData(footprintDescriptionRoot.data);

    // if(this.customDownloadFootprint){
    //     this.customDownloadFootprint(footprintDescriptionRoot);
    // }
    var ipcData = this.data.ipcParametricData();
    var packageType = IpcNameHelper.getPackageTypeFor3dModelGeneration(ipcData);
    var dataParams = this.data.root.jsonify(ipcData);

    if(this.customDownloadPackageData){
        dataParams['packageType'] = packageType;
        this.customDownloadPackageData(dataParams);
    }
    if(!this.useEditor){
        return;
    }

    this.dummyPackageData.footprintInstances.removeAll();
    this.dummyPackageData.footprintInstances.push(footprintInstance);
};


PackageGeneratorModel.prototype.generate3dModel = function() {
    var self = this;
    var ipcData = this.data.ipcParametricData();

    var packageType = IpcNameHelper.getPackageTypeFor3dModelGeneration(ipcData);
    var modelParams = IpcPackageParamHelper.getParamsForPackage(ipcData, self.dataUnit);

    // var dataParams = this.data.root.jsonify(ipcData);

    if(self.useLoadingScreen){
      this.processMessageModel.addLoad(this.processMessageKey, "Hold tight – Generating a 3D model for you...");
    }

    // if(self.customDownloadModelParameters){
    //     self.customDownloadModelParameters(packageType, modelParams);
    // }

    // if(self.customDownloadIPCData){
    //     self.customDownloadIPCData(dataParams);
    // }

    // if not using the editor, remove loading screen now,
    // and return.
    if(!self.useEditor && self.useLoadingScreen) {
        self.processMessageModel.removeLoad(self.processMessageKey);
    }

    if(!self.useEditor) {
        self.isParametricDataDirty(false);
        self.is3dModelParameterUpdated = false;
        return;
    }

    this.dataLoader.dataManager.generate3dModelForIPCPackageType(packageType, 'obj', modelParams, false)
    .then(function(modelJsonDescription) {
        self.createAndLoadDummyPackage(modelJsonDescription['obj'], modelJsonDescription['mtl']);

        self.processMessageModel.removeLoad(self.processMessageKey);

        self.showFinishButton(true);
        self.isParametricDataDirty(false);
        self.is3dModelParameterUpdated = false;

        //IPC data and generated 3d model are in sync in dummy package data
        self.dummyPackageData.isIPCDataAnd3DModelOutOfSync(false);

        //set is3dModelUploadedManually to false here so that after page reload 3d model is generated automatically even if a STEP file is uploaded before updating this preview
        self.data.root.rec();
        self.data.is3dModelUploadedManually(false);
        self.data.root.stopRec();
    })
    .catch(function(err) {
        self.processMessageModel.removeLoad(self.processMessageKey);

        // create a new error, server error has already been logged
        logError("PackageGeneratorModel", new Error("This 3D package could not be generated."), logError.criticality.MAJOR, "Please check your parameters and try again.", true);
    });
};

PackageGeneratorModel.prototype.generatePackage = function() {
    //generate footprint
    try {
        this.generateFootprintInstance();
    } catch(err){
        this.processMessageModel.removeLoad(this.processMessageKey);
        console.error(err);
        // create a new error, server error has already been logged
        logError("PackageGeneratorModel", new Error("The Footprint could not be generated."), logError.criticality.MAJOR, "Please check your parameters and try again.", true);
        return;
    }

    //generate 3d model if required
    if(this.is3dModelParameterUpdated) {
        this.generate3dModel();
    } else {
        if (this.useEditor) {
            this.data.root.rec();
            this.autoAlign3dModel();
            this.data.root.stopRec();

            this.showFinishButton(true);
        }

        this.isParametricDataDirty(false);
    }
};

PackageGeneratorModel.prototype.createAndLoadDummyPackage = function(obj, mtl) {
    var self = this;

    if(!obj) return;

    var model3dDummyData = new cio_datamodel.Model3dDummyData(obj, mtl);
    this.dummyPackageData.model3d(model3dDummyData);
};

PackageGeneratorModel.prototype.updatePackageViewerModel = function() {
    var self = this;

    this.dummyPackageData.calculateGeometryInfo()
    .then(function(info) {
        if(!self.useEditor) return;

        if(self.editorView.usingCanvas){
            self.editorView.makeWifreframe(info[0]);
        }

        self.packageViewerModel.packageGeometry(info[1]);

        //auto align 3d model in wizard mode only (generating a 3D package)
        if(self.masterModel && self.masterModel.wizardMode()) {
            self.data.root.rec();
            self.autoAlign3dModel(); //needs to be invoked before adding 3d model to the scene
            self.data.root.stopRec();
        }

        self.packageViewerModel.packageThreejsRenderGroup(info[0]);
    });
};

PackageGeneratorModel.prototype.autoAlign3dModel = function() {
    //do not use 3d model centroid as origin and auto align 3d model (to allow terminal to go through PCB board) for PTH package
    if(this.data.ipcParametricData() instanceof cio_datamodel.IpcDataModel.IpcPthPadGeneratorData) {
        this.packageViewerModel.modelCenterOrigin(false);
    } else if(this.data.ipcParametricData() instanceof cio_datamodel.IpcDataModel.IpcSmdPadGeneratorData) {
        this.packageViewerModel.modelCenterOrigin(true);
        this.packageViewerModel.placeDown(); //place SMD package on PCB board
    }

    //align 3d model origin to editor origin if the model is not a Box
    if(!(this.dummyPackageData.model3d() instanceof cio_datamodel.BoxData)) {
        this.packageViewerModel.center();
    }
};

PackageGeneratorModel.prototype.onIpcParametricDataUpdatedEvent = function(event) {
    this.isParametricDataDirty(true);

    if(this.data.ipcParametricData() && this.data.ipcParametricData().update3dModelNonTriggerList.indexOf(event.target.collection.getName()) === -1) {
        this.is3dModelParameterUpdated = true;
    }
};
